export const nomJours = [
	{ fr: "Lundi", oc: "Lo diluns" },
	{ fr: "Mardi", oc: "Lo dimars" },
	{ fr: "Mercredi", oc: "Lo dimècres" },
	{ fr: "Jeudi", oc: "Lo dijòus" },
	{ fr: "Vendredi", oc: "Lo divendres" },
	{ fr: "Samedi", oc: "Lo dissabte" },
	{ fr: "Dimanche", oc: "Lo dimenge" },
];

export const joursRef = {
	lundi: "#ed284c",
	mardi: "#56f068",
	mercredi: "#53b8e0",
	jeudi: "#e69130",
	vendredi: "#6171ff",
	samedi: "#85ff5c",
};

export let jours = { ...joursRef };
